import React from "react";

export const ErrorIcon = ({ className }: { className?: string }) => {
  return (
    <svg 
      width="17" 
      height="16" 
      viewBox="0 0 17 16" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path d="M6.99928 1.83333C7.64078 0.722222 9.24453 0.722222 9.88603 1.83333L15.6595 11.8333C16.301 12.9444 15.4992 14.3333 14.2162 14.3333H2.66915C1.38615 14.3333 0.584277 12.9444 1.22578 11.8333L6.99928 1.83333Z" fill="#F50A0A"/>
      <path d="M8.44266 6V7.66667M8.44266 11H8.45099M2.66915 14.3333H14.2162C15.4992 14.3333 16.301 12.9444 15.6595 11.8333L9.88603 1.83333C9.24453 0.722222 7.64078 0.722222 6.99928 1.83333L1.22578 11.8333C0.584277 12.9444 1.38615 14.3333 2.66915 14.3333Z" stroke="#F7F8F8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  );
};
